const featureFlags = {
  hideArticleBodyHyperlinks: 'hideArticleBodyHyperlinks',
};

export default featureFlags;
